import { showSxS, onCustomizationChange } from '../actions/publicActions';
import getOrCreateSxSStoreData from '../store/Store';
import { SxSCustomization } from '../store/schema/SxSStore';
import { mutator } from 'satcheljs';

function customizationMutator(actionMessage: { customization: SxSCustomization; sxsId: string }) {
    const { customization, sxsId } = actionMessage;
    if (customization !== null && customization !== undefined) {
        getOrCreateSxSStoreData(sxsId).customization = customization;
    }
}

mutator(showSxS, customizationMutator);
mutator(onCustomizationChange, customizationMutator);
